// extracted by mini-css-extract-plugin
export var active = "tabs-module--active--68a0e";
export var tab = "tabs-module--tab--1de89";
export var tabs = "tabs-module--tabs--33b58";
export var tabsWrapper = "tabs-module--tabsWrapper--6b952";